import Vue from "vue";
import Router from "vue-router";
import { CLIENT_NAME } from "@/config";
Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/reports",
      name: "ReportsHome",
      // meta: {
      //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
      // },
      component: () => import("@/components/ReportsHome"),
    },
    {
      path: "/",
      name: "LoginPage",
      // meta: {
      //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
      // },
      component: () => import("@/components/LoginPage"),
    },
    {
      path: "/AnalyticsSection",
      name: "AnalyticsSection",
      component: () => import("@/components/Analytics/AnalyticsSection"),
    },
    {
      path: "/booking-summary",
      name: "BookingSummary",
      meta: { subName: "Booking Summary" },

      component: () => import("@/components/Analytics/BookingSummary"),
    },
    {
      path: "/transaction-hourly",
      name: "transactionHourly",
      meta: { subName: "Transaction Hourly" },

      component: () =>
        import("@/components/Analytics/TransactionHourly/transactionHourly"),
    },
    {
      path: "/transaction-hourly/:hour/:fromDate/:toDate",
      name: "transactionHourlyDetailed",
      meta: { subName: "Transaction Hourly" },

      component: () =>
        import(
          "@/components/Analytics/TransactionHourly/transactionHourlyDetailed"
        ),
    },
    {
      path: "/cinema-wise-sales",
      name: "CinemaWiseSalesRecords",
      meta: { subName: "Cinema Wise Sales" },

      component: () =>
        import("@/components/Analytics/CinemaWiseSales/CinemaWiseSalesRecords"),
    },
    {
      path: "/cinema-wise-sales/:cinema_id/:fromDate/:toDate",
      name: "CinemaWiseMovieSales",
      meta: { subName: "Cinema Wise Sales" },

      component: () =>
        import("@/components/Analytics/CinemaWiseSales/CinemaWiseMovieSales"),
    },
    {
      path: "/movie-wise-sales",
      name: "MovieWiseSalesRecords",
      meta: { subName: "Movie Wise Sales" },

      component: () =>
        import("@/components/Analytics/MovieWiseSales/MovieWiseSalesRecords"),
    },
    {
      path: "/movie-wise-sales/:md_id/:fromDate/:toDate",
      name: "MovieWiseCinemaSales",
      meta: { subName: "Movie Wise Sales" },

      component: () =>
        import("@/components/Analytics/MovieWiseSales/MovieWiseCinemaSales"),
    },
    {
      path: "/sales-summary",
      name: "DailySalesReport",
      meta: { subName: "Daily Sales Report" },

      component: () =>
        import("@/components/Analytics/SalesSummary/dailySalesReport"),
    },
    {
      path: "/sales-summary/:cinema_id/:fromDate/:toDate",
      name: "DailySalesDetailedReport",
      meta: { subName: "Daily Sales Report" },

      component: () =>
        import("@/components/Analytics/SalesSummary/dailySalesDetailsReport"),
    },
    {
      path: "/schedule-report",
      name: "ScheduleReportVenue",
      meta: { subName: "Schedule Report" },

      component: () =>
        import("@/components/Analytics/ScheduleReport/scheduleVenues.vue"),
    },
    {
      path: "/schedule-report/:cinema_id",
      name: "ScheduleReportVenueBasedMovie",
      meta: { subName: "Schedule Report" },

      component: () =>
        import("@/components/Analytics/ScheduleReport/scheduledMovies.vue"),
    },
    {
      path: "/schedule-report/:cinema_id/:md_id",
      name: "cinemaMovieSchedules",
      meta: { subName: "Schedule Report" },

      component: () =>
        import(
          "@/components/Analytics/ScheduleReport/cinemaMovieSchedules.vue"
        ),
    },
    {
      path: "/schedule-movie-report/:md_id",
      name: "movieCinemaSchedules",
      meta: { subName: "Schedule Report" },

      component: () =>
        import(
          "@/components/Analytics/ScheduleReport/movieCinemaSchedules.vue"
        ),
    },
    {
      path: "/schedule-movie-report/:md_id/:cinema_id",
      name: "movieScheduledCinemaScreen",
      meta: { subName: "Schedule Report" },

      component: () =>
        import(
          "@/components/Analytics/ScheduleReport/movieScheduledCinemaScreen.vue"
        ),
    },
    {
      path: "/fb-sale-summary",
      name: "FnBSalesSummary",
      meta: { subName: "FB Sale Summary" },

      component: () =>
        import("@/components/Analytics/FBSalesSummary/fnbItemSales"),
    },
    {
      path: "/fb-sale-summary/:source_type/:fromDate/:toDate",
      name: "FnBSalesCinemaSummary",
      meta: { subName: "FB Sale Summary" },

      component: () =>
        import("@/components/Analytics/FBSalesSummary/fbSalesCinemaSummary"),
    },
    {
      path: "/fb-sale-summary/:cinema_id/:source_type/:fromDate/:toDate",
      name: "FnBSalesItemCinemaWiseSummary",
      meta: { subName: "FB Sale Summary" },

      component: () =>
        import("@/components/Analytics/FBSalesSummary/fnbSalesItemSummary"),
    },
    {
      path: "/occupancy-report",
      name: "cinemaOccupancyReport",
      meta: { subName: "Occupancy Report" },

      component: () =>
        import("@/components/Analytics/OccupancyReport/cinemaOccupancy"),
    },
    {
      path: "/occupancy-report/:cinema_id",
      name: "movieOccupancyReport",
      meta: { subName: "Occupancy Report" },

      component: () =>
        import("@/components/Analytics/OccupancyReport/movieOccupancy"),
    },
    {
      path: "/occupancy-report/:cinema_id/:md_id",
      name: "screenOccupancyReport",
      meta: { subName: "Occupancy Report" },

      component: () =>
        import("@/components/Analytics/OccupancyReport/screenOccupancy"),
    },
    {
      path: "/week-wise-movie-history",
      name: "weekWiseMovieHistory",
      meta: { subName: "Week Wise Movie History Report" },

      component: () => import("@/components/Analytics/MovieHistoryReport/weekWiseMovieHistory"),
    },
    {
      path: "/movie-summary-report",
      name: "movieSummaryReport",
      meta: { subName: "Movie Summary Report" },

      component: () => import("@/components/Analytics/MovieHistoryReport/movieSummaryReport"),
    },
    {
      path: "/movie-show-wise-report",
      name: "movieShowWiseReport",
      meta: { subName: "Movie Show Wise Report" },

      component: () => import("@/components/Analytics/movieShowWiseReport"),
    },
    // {
    //   path: "/fnb-chart",
    //   name: "Fnb Chart",
    //   // meta: {
    //   //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
    //   // },
    //   component: () => import("@/components/FnbChart"),
    // },
  ],

  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  console.log({ to, from });
  let isAuthenticated = localStorage.getItem("IsloggedIn") == "Y";

  if (isAuthenticated && to.name == "LoginPage") next({ name: "ReportsHome" });

  if (to.name !== "LoginPage" && !isAuthenticated) next({ name: "LoginPage" });
  else next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js